"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regexp = /^\D*3[47]/;
const types = {
    0: 'credit-card-alt',
    3: 'cc-amex',
    4: 'cc-visa',
    5: 'cc-mastercard',
    6: 'cc-discover',
};
function getDigitsCount(val) {
    return regexp.test(val) ? 15 : 16; // 15 digits if Amex
}
function getType(cardNumber) {
    const val = cardNumber + '';
    const firstDigit = +(val && val[0]) || 0;
    return types[firstDigit] || types[0];
}
exports.default = {
    DEFAULT: types[0],
    getDigitsCount,
    getType,
};
//# sourceMappingURL=creditCard.js.map